import React, { useContext, useEffect, useState } from 'react';
import { Nav, Tab } from "react-bootstrap";
import { useParams, useLocation } from 'react-router';
import utilsHomePage from '../../../MyConns/_Utils/utilsHomePage';
import Breadcrumb from './Breadcrumb';
import { HomePContext } from '../../MyContexts/HomeP_Context';
import { useHistory } from "react-router-dom";
import SucessToast from '../../MySections/Toasts/SucessToast';
import TabPageDetails from '../compsForAllPages/TabPageDetails';
import TabFavoRests from './parts/TabFavoRests';
import TabHPTopSliders from './parts/TabHPTopSliders';
import TabHPheaders from './parts/TabHPheaders';
import TabHPBottomSliders from './parts/TabHPBottomSliders';
import TabMainRests from './parts/TabMainRests';
import TabCenterSliders from './parts/TabCenterSliders';

const HomePSet = (props) => {
    const history = useHistory();
    const location = useLocation();
    const [homeP, setHomeP] = useContext(HomePContext);
    const [loading, setLoading] = useState(true);
    const [activeTab, setActiveTab] = useState("tab5"); // Default tab
    let idParam = useParams();
    const [thePopUp, setThePopUp] = useState("");

    useEffect(() => {
        // Retrieve the active tab from localStorage for this specific path
        const activeTabFromStorage = localStorage.getItem(`${location.pathname}_activeTab`);
        setActiveTab(activeTabFromStorage || 'tab5'); // Set default tab if none is found
        getHomeP();

       
    }, [location.pathname]);

    const tempUpdate = (upRest) => {
        setHomeP(upRest);
    }

    const getHomeP = async () => {
        let HomePLst = await utilsHomePage.getHomePage();
        setHomeP(HomePLst);
        setLoading(false);
    }

    const updateTheHomeP = async () => {
        let HomePLst = await utilsHomePage.updateHomePage(homeP);
        setHomeP({ ...homeP });
        SucessToast({ position: "toast-bottom-right", text: "עודכן בהצלחה!" });
    }

    const handleSelect = (key) => {
        localStorage.setItem(`${location.pathname}_activeTab`, key); // Save selected tab to localStorage
        setActiveTab(key); // Update active tab state
    }

    return (
        <div className="ms-content-wrapper SetBlock">
            <Breadcrumb />
            <div className="row">
                <div className="col-md-12">
                    <div className="ms-panel">
                        <div className="ms-panel-header">
                            <div><h6>הגדרות עמוד הבית</h6></div>
                            <div className={"buisTollBar"}></div>
                        </div>
                        {loading ? "loading" :
                            <div className="col-md-12">
                                <div className="ms-panel-body clearfix">
                                    <Tab.Container activeKey={activeTab} onSelect={handleSelect}>
                                        <Nav variant="tabs" className="nav nav-tabs d-flex nav-justified mb-2">
                                            <Nav.Item>
                                                <Nav.Link eventKey="tab5">כותרות</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link eventKey="tab2">סליידר עליון</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link eventKey="tab3">סליידר תחתון</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link eventKey="tab4">סליידרים אמצע </Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link eventKey="tab1">פרטי העמוד</Nav.Link>
                                            </Nav.Item>
                                        </Nav>
                                        <Tab.Content>
                                            <Tab.Pane eventKey="tab5">
                                                <div className="form-row tabsInputs ">
                                                    <TabHPheaders />
                                                </div>
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="tab2">
                                                <div className="form-row tabsInputs ">
                                                    <TabHPTopSliders />
                                                </div>
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="tab3">
                                                <div className="form-row tabsInputs ">
                                                    <TabHPBottomSliders />
                                                </div>
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="tab1">
                                                <div className="form-row tabsInputs ">
                                                    <TabPageDetails thePage={homeP} thePageUpdate={(key, val) => { homeP[key] = val }} />
                                                </div>
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="tab4">
                                                <div className="form-row tabsInputs ">
                                                    <TabCenterSliders thePage={homeP} thePageUpdate={(key, val) => { homeP[key] = val }} />
                                                </div>
                                            </Tab.Pane>
                                        </Tab.Content>
                                    </Tab.Container>
                                </div>
                            </div>}
                    </div>
                </div>
            </div>
            <div className="ms-panel-header approveLine">
                <button type="button" className="onLeft btn btn-primary" onClick={() => updateTheHomeP()}>שמור</button>
            </div>
        </div>
    );
}

export default HomePSet;
